import React, { Component } from 'react';
import { Icon, Label, Menu, Table } from 'semantic-ui-react';
import axios from 'axios'
import { serverIp, toCurrency } from '../../../../config/constants';


class AworiLogTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
        }
    }

    componentDidMount() {
        console.log("cpx1 ======componentDidMount");
        this.getTransactions();
    }

    getTransactions = () => {
        console.log("cpx1 ======getTransactions");

        this.setState({ loading: true })

        axios.post(serverIp + 'awori/getLastTransactions', {
            apiKey: "getLastTransactions",
            numRecords: 30
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    this.setState({ transactions: response.data.aworiLogTransactions });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get transactions:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const tableRow = this.state.transactions.length > 0
            ? this.state.transactions.map((trans) =>
                <Table.Row>
                    <Table.Cell> {trans.daDate} </Table.Cell>
                    <Table.Cell positive>{toCurrency(trans.depositAmount)}</Table.Cell>
                    <Table.Cell error>{toCurrency(trans.deductAmount)}</Table.Cell>
                    <Table.Cell>{toCurrency(trans.oldBalance)}</Table.Cell>
                    <Table.Cell>{trans.reason}</Table.Cell>
                </Table.Row>)
            : ''

        return (<div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Deposit Amount</Table.HeaderCell>
                        <Table.HeaderCell>Deduct Amount</Table.HeaderCell>
                        <Table.HeaderCell>Old Balance</Table.HeaderCell>
                        <Table.HeaderCell>Reason</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>
        </div>);
    }
}

export default AworiLogTransactions;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/AworiLog/AworiLogTransactions.js